import React from 'react';
import classes from './WaveRoster.module.css';
const WaveRosterDetails = (props) => {
    return (
        <div className={classes.waveRosterData}>
            {props.waveRoster.map((waveRosterData, i) => {
                return (
                    <div key={i} className={classes.waveRosterItem}>{waveRosterData.WaveId}<span className={classes.dataColor}> (ID:{waveRosterData.RosterId} <span  className={'blueColor'}>{waveRosterData.ActiveCount}</span><span className={'blueColor'}> / </span> <span className={(waveRosterData.FTRRCount === waveRosterData.ActiveCount ? 'blueColor' : 'redColor')}>{waveRosterData.FTRRCount}</span><span className={'blueColor'}> / </span ><span className={(waveRosterData.ETPCount === waveRosterData.ActiveCount ? 'blueColor' : 'redColor')}>{waveRosterData.ETPCount}</span>)</span></div>
                )
            })}
        </div>
    )
}

export default WaveRosterDetails;